import BaseComponent from "../../../../lib/components/BaseComponent";
import CnerOverview from "./CnerOverview";
import Layout from "../../components/layout/Layout";
import React, {createRef} from "react";
import Header from "../../../../lib/components/header/Header";
import SideBar from "../../components/sideBar/SideBar";
import CM from "../../../model/system/CM";
import GetUserContext from "../../../../lib/model/service/system/dto/GetUserContext";
import HorizontalTabBar from "../../components/tabbar/HorizontalTabBar";
import BaseTab from "../../components/tabbar/BaseTab";
import SystemService from "../../../../lib/model/service/system/SystemService";
import SysLastValueWrite from "../../../../lib/model/service/system/dto/SysLastValueWrite";

class CnerMain extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      accounts: [], selectedAccount: null, avatarLink: undefined
    }
    this.layoutRef = createRef();
    this.tabSideBarRef = createRef();
    this.horizontalTabBarRef = createRef();
    CM.get().setPanel(this);
  }

  componentDidMount() {
    this.horizontalTabBarRef.current.addTab(<BaseTab tabTitle={'Übersicht'} notClosable/>, <CnerOverview ref={createRef()}/>);
    this.fetchData();
  }

  fetchData() {
    let self = this;
    CM.get().doJsonAjax(CM.get().getServiceUrl('SystemService'), new GetUserContext(), function(responseUserContext) {
      if (responseUserContext.success) {
        CM.get().setUserContext(responseUserContext.data);
        self.state.selectedAccount = responseUserContext.data.accounts[0];
        self.state.accounts = responseUserContext.data.allowedAccounts;
        self.state.avatarLink = responseUserContext.data.avatar;
        self.setState(self.state);

        let found = false;
        for (let sysLastValue of responseUserContext.data.userSettings.sysLastValue) {
          if (sysLastValue.valueid === 'cner21.isFirstTimeLogin') {
            if (sysLastValue.value === '"true"') {
              found = true;
              break;
            }
          }
        }
        if (!found) {
          SystemService.doRequest(new SysLastValueWrite('cner21.isFirstTimeLogin', 'true'), (response) => {
            window.location.href = CM.get().getBaseUrl() + 'changesGhWvFomsqfhSfjH6Sf4HsfjK0hShXddtajWgR2Hfa';
          }, 'Es konnten keine Daten geliefert werden!');
        }
      }
    });
  }

  render() {
    return <Layout className='CNINFO-CnerMain h-full' ref={this.layoutRef} topNav={
      <Header className='CNINFO-CnerMain-Header' accounts={this.state.accounts} selectedAccount={this.state.selectedAccount} version={'2.2'}/>}
                   sideBar={<SideBar ref={this.tabSideBarRef} avatar={this.state.avatarLink}/>}>

      <HorizontalTabBar className='CNINFO-CnerMain-TabContainer h-full p-2' ref={this.horizontalTabBarRef}/>
    </Layout>;
  }
}

export default CnerMain;
